"use strict";

var docsWidget = function () {
  var docsRowTemplate = '';
  var docsWidgetParams = {
    model: {},
    url: {},
    template: {}
  };

  function renderAddDocButton(data) {
    var $moreDocsBtn = $('#moreDocsBtn');

    if (data.IsDisplayAddDockButton) {
      $moreDocsBtn.show();
    } else {
      $moreDocsBtn.hide();
    }
  }

  function getRequestData() {
    return {
      url: docsWidgetParams.url.getDocs,
      id: docsWidgetParams.model.id,
      filter: docsWidgetParams.model.filter,
      serviceIds: docsWidgetParams.model.serviceTypeIds,
      skip: docsWidgetParams.model.skip,
      limit: docsWidgetParams.model.itemsLimit
    };
  }

  function getDocs(callback) {
    var req = getRequestData();
    $.ajax({
      url: req.url,
      type: 'POST',
      data: {
        entityId: req.id,
        docFilter: req.filter,
        serviceIds: req.serviceIds,
        skip: req.skip,
        take: req.limit
      },
      success: function success(data) {
        callback(data);
      }
    });
  }

  function appendDocList(data) {
    var $docsList = $('.docs');
    $docsList.append(docsRowTemplate.render({
      Documents: data.Documents
    }));
    renderAddDocButton(data);
  }

  function renderDocList(data) {
    var $docsList = $('.docs');
    $docsList.html(docsRowTemplate.render({
      Documents: data.Documents
    }));
    renderAddDocButton(data);
  }

  function resetServiceTypesIds() {
    docsWidgetParams.model.skip = 0;
    docsWidgetParams.model.serviceTypeIds = [];
  }

  function findSelectedIdFromServiceTypeIds(allServiceTypes, selectedId) {
    return _.find(allServiceTypes, function (item) {
      return item.index === selectedId;
    }).value;
  }

  function pushSelectedIdToServiceTypeIdList(selectDataContext) {
    _.forEach(selectDataContext.state.selectedIdx, function (id) {
      if (id != 0) {
        var selectedId = findSelectedIdFromServiceTypeIds(selectDataContext.items, id);
        docsWidgetParams.model.serviceTypeIds.push(selectedId);
      }
    });
  }

  function bindHandlers() {
    $(document).on('click', '.docs-section-link', function (e) {
      e.preventDefault();
      var $this = $(this);
      var filter = $this.attr('data-filter');
      $('.docs-sections .tab').removeClass('-active');
      $this.parent().addClass('-active');
      docsWidgetParams.model.filter = filter;
      docsWidgetParams.model.skip = 0;
      getDocs(function (docs) {
        renderDocList(docs.Result);
      });
      docsWidgetParams.model.skip += docsWidgetParams.model.itemsLimit;
      window.history.replaceState('', 'Title', $this.attr('href'));
    });
    $(document).on('click', '#moreDocsBtn', function () {
      getDocs(function (docs) {
        appendDocList(docs.Result);
      });
      docsWidgetParams.model.skip += docsWidgetParams.model.itemsLimit;
    });
  }

  function initPlugins() {
    $('#serviceTypes').selectric({
      disableOnMobile: false,
      onChange: function onChange(element, selectData) {
        resetServiceTypesIds();
        pushSelectedIdToServiceTypeIdList(selectData);
        getDocs(function (docs) {
          renderDocList(docs.Result);
        });
        docsWidgetParams.model.skip += docsWidgetParams.model.itemsLimit;
      },
      optionsItemBuilder: function optionsItemBuilder(itemData) {
        return "<div class=\"selectric-checkbox\">".concat(itemData.text, "</div>");
      }
    });
    $('.docs-filter-wrap').css('visibility', 'visible');
  }

  function unbindHandlers() {
    $(document).off('click', '.docs-section-link');
    $(document).off('change', '#serviceTypes');
    $(document).off('click', '#moreDocsBtn');
  }

  function compileTemplates() {
    docsRowTemplate = Hogan.compile(docsWidgetParams.template.doc);
  }

  function setParams(docsParams) {
    docsWidgetParams = $.extend({}, docsWidgetParams, docsParams);
  }

  function init(docsParams) {
    unbindHandlers();
    setParams(docsParams);
    compileTemplates();
    initPlugins();
    bindHandlers();
  }

  return {
    init: init
  };
}();